import { render, staticRenderFns } from "./TradeRecords.vue?vue&type=template&id=f254e172"
import script from "./TradeRecords.vue?vue&type=script&lang=js"
export * from "./TradeRecords.vue?vue&type=script&lang=js"
import style0 from "./TradeRecords.vue?vue&type=style&index=0&id=f254e172&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports